import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { TrackingService } from '../../servicios/tracking.service';

@Component({
  selector: 'app-envia',
  templateUrl: './envia.component.html',
  styleUrls: ['./envia.component.scss']
})
export class EnviaComponent implements OnInit {
  id: any;
  servicio: any;
  pedidos: any = [];

  guia: string;
  cuenta: string;
  novedad1: string;
  novedad2: string;
  novedad3: string;
  aclaracion: string;
  valor: string;
  valor2: number;
  loading: boolean;
  novedad: boolean;
  imagen: boolean;
  /*imagen2: string;
  imagen3: string;*/

  num: String;
  array = [];

  constructor(protected serviceService: TrackingService, private route: ActivatedRoute) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      //console.log('este es el id ' + params.get('id'));
      this.id = params.get('id');
      /* Dos Parametros para el parametro 'serv'
      c = con servicio de envia
      s = con servicio de triidy */
      this.servicio = params.get('serv');

      //INICIALIZANDO VACIOS
      this.loading = true;
      this.pedidos = [];
      this.array = [];
      this.guia = '';
      this.num = '';
      this.novedad1 = '';
      this.novedad2 = '';
      this.novedad3 = '------';
      this.aclaracion = '------';
      this.valor = '';
      this.valor2 = 0;
      this.novedad = true;
      this.imagen = true;
      /*this.imagen2 = '';
      this.imagen3 = '';*/


      //console.log(this.servicio);
      //BUSCADOR
      if (this.servicio === 's') {
        this.rastreador(this.id);
      } else if (this.servicio === 'c') {
        this.rastreador2(this.id);
      }
    });
  }

  rastreador(id: any) {
    // console.log('Servicio Triidy');

    this.serviceService.getTrackEnvia(1, id).subscribe((data: any) => {

      // console.log(data);

      this.pedidos = data;
      this.loading = false;
      this.guia = this.pedidos['guia'];
      //console.log("esta es la guia: " + this.guia);

      this.cuenta = this.pedidos['cuenta'];
      this.cuenta = this.cuenta.substring(15, 52);

      this.valor = this.pedidos['declarado'];
      this.valor2 = parseInt(this.valor);
      this.valor = this.valor2.toFixed();

      try {
        this.novedad1 = this.pedidos['novedad'];
        // console.log('Estas es la novedad: ' + this.novedad1);
        if (this.novedad1 != null) {
          let status;
          status = this.pedidos.estado;
          status = status.toLowerCase();
          if (status.includes('en novedad') || status.includes('En novedad') || status.includes('En Novedad')) {
            this.novedad = false;
            this.novedad2 = this.novedad1['0'];
            this.novedad3 = this.novedad2['novedad'];
            this.aclaracion = this.novedad2['aclaracion'];
          }
        }

        //console.log("imagen " + this.pedidos['imagen']);

        if (this.pedidos['imagen'] !== '') {
          this.imagen = false;
        }

      } catch (error) {
        console.error(error);
      }
      /*
            this.imagen2 = this.pedidos['imagen'];
            console.log('esta es la url: ' + this.imagen2);
            console.log('esta es la url: ' + this.imagen2.slice(0, this.imagen2.length-3));
            this.imagen3 = this.imagen2.slice(0, this.imagen2.length-3) + 'jpg';
            console.log('esta es la url: ' + this.imagen3);
      */
      const maxNumber = this.guia.length;
      for (let i = 0; i < maxNumber; i++) {
        this.num = this.guia.charAt(i);
        this.array.push(this.num);
      }
      //console.log(this.array);
    },
      (error) => {
        // console.error(error.status)
        if (error.status === 400) {
          this.serviceService.getTrackEnvia(0, id).subscribe((data: any) => {

            // console.log(data);

            this.pedidos = data;
            this.loading = false;
            this.guia = this.pedidos['guia'];
            //console.log("esta es la guia: " + this.guia);

            this.cuenta = this.pedidos['cuenta'];
            this.cuenta = this.cuenta.substring(15, 52);

            this.valor = this.pedidos['declarado'];
            this.valor2 = parseInt(this.valor);
            this.valor = this.valor2.toFixed();

            try {
              this.novedad1 = this.pedidos['novedad'];
              //console.log('Estas es la novedad: ' + this.novedad1);
              if (this.novedad1 != null) {
                let status;
                status = this.pedidos.estado;
                status = status.toLowerCase();
                if (status.includes('en novedad') || status.includes('En novedad') || status.includes('En Novedad')) {
                  this.novedad = false;
                  this.novedad2 = this.novedad1['0'];
                  this.novedad3 = this.novedad2['novedad'];
                  this.aclaracion = this.novedad2['aclaracion'];
                }
              }

              //console.log("imagen " + this.pedidos['imagen']);

              if (this.pedidos['imagen'] !== '') {
                this.imagen = false;
              }

            } catch (error) {
              console.error(error);
            }
            /*
                  this.imagen2 = this.pedidos['imagen'];
                  console.log('esta es la url: ' + this.imagen2);
                  console.log('esta es la url: ' + this.imagen2.slice(0, this.imagen2.length-3));
                  this.imagen3 = this.imagen2.slice(0, this.imagen2.length-3) + 'jpg';
                  console.log('esta es la url: ' + this.imagen3);
            */
            const maxNumber = this.guia.length;
            for (let i = 0; i < maxNumber; i++) {
              this.num = this.guia.charAt(i);
              this.array.push(this.num);
            }
            //console.log(this.array);
          },
            (error) => {
              // console.error(error.status)
              setTimeout(function () {
                Swal.fire({
                  title: 'Error!',
                  text: 'Servidor no reconoce los datos',
                  icon: 'error',
                  confirmButtonText: 'Aceptar'
                })
                if (error.status === 400) {
                  // console.log(true)
                }
              }, 3000);
            });
        }
      });
  }


  rastreador2(id: any) {
    // console.log('Servicio Envia');

    this.serviceService.getTrack(id).subscribe((data: any) => {

      // console.log(data);

      this.pedidos = data;
      this.loading = false;
      this.guia = this.pedidos['guia'];
      //console.log("esta es la guia: " + this.guia);

      this.cuenta = this.pedidos['cuenta'];
      this.cuenta = this.cuenta.substring(15, 52);

      this.valor = this.pedidos['declarado'];
      this.valor2 = parseInt(this.valor);
      this.valor = this.valor2.toFixed();

      try {
        this.novedad1 = this.pedidos['novedad'];
        // console.log('Estas es la novedad: ' + this.novedad1);
        if (this.novedad1 != null) {
          let status;
          status = this.pedidos.estado;
          status = status.toLowerCase();
          if (status.includes('en novedad') || status.includes('En novedad') || status.includes('En Novedad')) {
            this.novedad = false;
            this.novedad2 = this.novedad1['0'];
            this.novedad3 = this.novedad2['novedad'];
            this.aclaracion = this.novedad2['aclaracion'];
          }
        }

        //console.log("imagen " + this.pedidos['imagen']);

        if (this.pedidos['imagen'] !== '') {
          this.imagen = false;
        }

      } catch (error) {
        console.error(error);
      }
      /*
            this.imagen2 = this.pedidos['imagen'];
            console.log('esta es la url: ' + this.imagen2);
            console.log('esta es la url: ' + this.imagen2.slice(0, this.imagen2.length-3));
            this.imagen3 = this.imagen2.slice(0, this.imagen2.length-3) + 'jpg';
            console.log('esta es la url: ' + this.imagen3);
      */
      const maxNumber = this.guia.length;
      for (let i = 0; i < maxNumber; i++) {
        this.num = this.guia.charAt(i);
        this.array.push(this.num);
      }
      //console.log(this.array);
    },
      (error) => {
        // console.error(error.status)
        if (error.status === 400) {
          this.serviceService.getTrackOp(id).subscribe((data: any) => {

            // console.log(data);

            this.pedidos = data;
            this.loading = false;
            this.guia = this.pedidos['guia'];
            //console.log("esta es la guia: " + this.guia);

            this.cuenta = this.pedidos['cuenta'];
            this.cuenta = this.cuenta.substring(15, 52);

            this.valor = this.pedidos['declarado'];
            this.valor2 = parseInt(this.valor);
            this.valor = this.valor2.toFixed();

            try {
              this.novedad1 = this.pedidos['novedad'];
              //console.log('Estas es la novedad: ' + this.novedad1);
              if (this.novedad1 != null) {
                let status;
                status = this.pedidos.estado;
                status = status.toLowerCase();
                if (status.includes('en novedad') || status.includes('En novedad') || status.includes('En Novedad')) {
                  this.novedad = false;
                  this.novedad2 = this.novedad1['0'];
                  this.novedad3 = this.novedad2['novedad'];
                  this.aclaracion = this.novedad2['aclaracion'];
                }
              }

              //console.log("imagen " + this.pedidos['imagen']);

              if (this.pedidos['imagen'] !== '') {
                this.imagen = false;
              }

            } catch (error) {
              console.error(error);
            }
            /*
                  this.imagen2 = this.pedidos['imagen'];
                  console.log('esta es la url: ' + this.imagen2);
                  console.log('esta es la url: ' + this.imagen2.slice(0, this.imagen2.length-3));
                  this.imagen3 = this.imagen2.slice(0, this.imagen2.length-3) + 'jpg';
                  console.log('esta es la url: ' + this.imagen3);
            */
            const maxNumber = this.guia.length;
            for (let i = 0; i < maxNumber; i++) {
              this.num = this.guia.charAt(i);
              this.array.push(this.num);
            }
            //console.log(this.array);
          },
            (error) => {
              // console.error(error.status)
              setTimeout(function () {
                Swal.fire({
                  title: 'Error!',
                  text: 'Servidor no reconoce los datos',
                  icon: 'error',
                  confirmButtonText: 'Aceptar'
                })
                if (error.status === 400) {
                  // console.log(true)
                }
              }, 3000);
            });
        }
      });
  }

}
